<style lang="scss">
    .basechannel .ivu-form-item{
        margin-bottom:10px
    }
    .basechannel .ivu-form-item-content{
        line-height: 32px;
    }
    .chalbasetable{
        margin-left:120px;margin-bottom:15px;
        .vview-table td, .vview-table th{
            padding-left:15px;
        }
    }
</style>
<template>
    <div>
        <Form :label-width="130" :model="formData" class="margin-15 clearfix basechannel" ref="baseform">
            <Col span="24">
                <Col span="12">
                    <FormItem label='产品类型' v-if="alltype == 'query' || alltype == 'edit'">
                        <div>{{formData.type | filterType}}</div>
                    </FormItem>
                    <FormItem v-else label='产品类型' prop="type" :rules="required">
                        <Select v-model="formData.type" @on-change="changetable(formData.type)">
                            <Option value="single">简单产品</Option>
                            <Option value="bundle">组合产品</Option>
                            <Option value="virtual">虚拟产品</Option>
                        </Select>
                        <span class="color-error line-28">组合产品为一个Seller SKU对应多个ERP SKU的情况，虚拟产品可以不维护ERP SKU对应关系</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='店铺' v-if="alltype == 'query' || alltype == 'edit'">
                        <div>{{formData.accountFlag}}</div>
                    </FormItem>
                    <FormItem v-else label='店铺' prop="accountFlag" :rules="required">
                        <Select v-model="formData.accountFlag" filterable clearable @on-change="changeChannel(formData.accountFlag)">
                            <Option v-for="item in getNewAccountList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="formData.type!='virtual'">
                <Col span="12">
                    <FormItem label='ERPSKU' v-if="alltype == 'query' || alltype == 'edit'">
                        {{formData.erpSku}}
                    </FormItem>
                    <FormItem label='ERPSKU' prop="erpSku" :rules="required" v-else>
                        <Select clearable filterable v-model="formData.erpSku" ref="zierpselect" @on-open-change="clickblur" remote :remote-method="remoteMethod1" :loading="loading1" @on-change="searcherpsku(formData.erpSku)">
                            <Option v-for="json in erpSkusList" :value="json.name" :key="json.id">{{ json.name }}</Option>
                        </Select>
                        <span class="color-error">组合产品只能选择同一个项目的ERP SKU</span>
                    </FormItem>
                </Col>
                <Col span="12" >
                    <FormItem label='项目'>
                        {{formData.lineId | transferText('name',products)}}
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="showzuhe">
                <Col span="12">
                    <vTable
                    class="chalbasetable"
                    :columns="columns" 
                    :data="formList"
                    size="small" 
                    ref="table"  
                    border 
                    stripe></vTable>
                </Col>
            </Col>

            <Col span="24">
                <Col span="12">
                    <FormItem label='SellerSKU' v-if="alltype == 'query' || alltype == 'edit'">
                        {{formData.sellerSku}}
                    </FormItem>
                    <FormItem label='SellerSKU' prop="sellerSku" :rules="required" v-else>
                        <Input v-model="formData.sellerSku"></Input>
                        <span class="color-error">产品在店铺上的SKU</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='币种' v-if="alltype == 'query' || alltype == 'edit'">
                        {{formData.currencyCode}}
                    </FormItem>
                    <FormItem label='币种' prop="currencyCode" :rules="required" v-else>
                        {{formData.currencyCode}}
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="formData.type!='virtual'">
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='发货方式'>
                        <span class="font-weight">{{formData.skuOrderType == 0 ? '自动' : '手动'}}</span>
                    </FormItem>
                    <FormItem v-else label='发货方式' prop="skuOrderType" :rules="required">
                        <div >
                            <RadioGroup v-model="formData.skuOrderType">
                                <Radio :label="0">
                                    <Icon type="social-yes"></Icon>
                                    <span>自动</span>
                                </Radio>
                                <Radio :label="1">
                                    <Icon type="social-no"></Icon>
                                    <span>手动</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='上下架状态'>
                        <span class="font-weight">{{formData.saleState | filterSalestate}}</span>
                    </FormItem>
                    <FormItem v-else label='上下架状态' prop="saleState" :rules="required">
                        <Select v-model="formData.saleState">
                            <Option value="Hit Shelve">上架</Option>
                            <Option value="Off Shelve">临时下架</Option>
                            <Option value="Not Sell">下架</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Col>
            <Col span="24" v-if="formData.type!='virtual'">
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='Asin'>
                        <span class="font-weight">{{formData.asin}}</span>
                    </FormItem>
                    <FormItem v-else label='Asin'>
                        <Input v-model="formData.asin"></Input>
                        <span class="color-error">亚马逊店铺必填</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label='是否推送库存'>
                        <span class="font-weight">{{formData.isPush == 'Y' ? '是' : '否'}}</span>
                    </FormItem>
                    <FormItem v-else label='是否推送库存' prop="isPush" :rules="required">
                        <div >
                            <RadioGroup v-model="formData.isPush">
                                <Radio label="Y">
                                    <Icon type="social-yes"></Icon>
                                    <span>是</span>
                                </Radio>
                                <Radio label="N">
                                    <Icon type="social-no"></Icon>
                                    <span>否</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                        <span class="color-error">选择是，会将库存分配计算结果推送至平台且需配合库存推送使用</span>
                    </FormItem>
                </Col>
            </Col>
            <Col span="12" v-if="formData.type!='virtual'">
                <FormItem v-if="alltype == 'query'" label='Handling time'>
                    <span class="font-weight">{{formData.handelingTime}}</span>
                </FormItem>
                <FormItem v-else label='Handling time'>
                    <Input v-model="formData.handelingTime"></Input>
                    <span class="color-error">订单处理时间（从获取订单到有物流信息的时间）仅适用于亚马逊，且需配合库存推送使用</span>
                </FormItem>
            </Col>
        </Form>
    </div>
</template>

<script>
import { HttpVsSkuList } from '@/service/boss/allot';
import { mapState, mapGetters } from "vuex";
export default {
    props:['alltype','basedata'],
    data(){
        return {
            showzuhe:false,
            formData:{
                lineId:'',
                saleState:'Hit Shelve',
                type:'single',
                isInsurance:"Y",
                skuOrderType:0,
                isPush:'N',
                handelingTime:3,
            },
            warehouseList:[],
            formList:[],
            loading1:false,
            erpSkusList:[],
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],  
        }
    },
    // created(){
    //     console.log(this.basedata)
    // },
    computed:{
        ...mapState('boss', ['products', 'accountTypes', 'accounts']),
        ...mapGetters('diction',['getNewAccountList']),
        columns() {
            const _this = this;
            const showwidth = this.alltype == 'add'
            return [{
                title: 'ERPSKU',
                key: 'erpSku',
                render(h, { row }) {
                    if(_this.alltype=='add'){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.erpSku,
                                readonly:true,
                            },
                            on: {
                                'input':(event) => {
                                    row.erpSku = event
                                    _this.formList[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.erpSku}</div>
                    }
                }
            }, {
                title: '数量',
                key: 'qty',
                width:150,
                render(h, { row,index }) {
                    if(_this.alltype=='add'){
                        return h('InputNumber',{
                            props: {
                                size:'small',
                                min:1,
                                value:row.qty
                            },
                            on: {
                                'input': (event) => {
                                    row.qty = event
                                    // console.log(event)
                                    _this.formList[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.qty}</div>
                    }
                    // return <div>{row.qty}</div>
                }
            },  
            {
                title: '操作',
                width: _this.alltype=='add' ? 80 : 0,
                render(h, { row,index }) {
                    // console.log(_this.alltype=='add')
                    if(_this.alltype=='add'){
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: "error",
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.remove(index, row.id)
                                    }
                                }
                            }, '删除')
                        ])
                    }else{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: "error",
                                    size: 'small',
                                    disabled:true
                                },
                                on: {
                                    click: () => {
                                       
                                    }
                                }
                            }, '删除')
                        ])
                    }
                    
                }
            },
            ]
        },
    },
    methods:{
        // 切换渠道，换对应的币种
        changeChannel(value){
            // console.log(value)
            let objitem;
            objitem = this.getNewAccountList.filter(item=> item.value == value)
            // console.log(objitem)
            this.formData.currencyCode = objitem[0].attach.currency
            
            this.$emit('on-currency',objitem[0].attach.currency)
        },
        handledata(){
            // console.log(this.basedata)
            this.formData = this.basedata;
            this.formList = this.basedata.productChannelRelateList
            if(this.alltype != 'add'){
                if(this.formData.type=='bundle'){
                    this.showzuhe = true
                }
            }
        },
        remoteMethod1(query){
            this.loading1 = true;
            HttpVsSkuList({page: 1,rows: 100,'search[CN_erpSku]':query}).then(res => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    // console.log(item)
                    return { name: item.erpSku, id: item.id, title:item.nameEn, lineId:item.lineId }
                });
            });
        },
        clickblur(type){
            if(type==false){
                if(!this.formData.erpSku){
                    this.$refs.zierpselect.clearSingleSelect()
                }
            }
        },
        searcherpsku(erpSku){

            // console.log(erpSku)
            if(erpSku){
                let productsItem = this.erpSkusList.filter(item=>{
                    return item.name == erpSku
                })
    
                // 项目填入
                this.formData.lineId = productsItem[0].lineId
                
                if(productsItem.length>0){
                    let obj = {
                        erpSku:productsItem[0].name,
                        qty:0,
                        productId:productsItem[0].id
                    }
                    this.formList.push(obj)
                }
            }
            // console.log(obj)
        },
        remove(index){
            this.formList.splice(index,1)
        },
        changetable(type){
            if(type=='bundle'){
                this.showzuhe = true
            }else{
                this.showzuhe = false
            }
        },
        async validate(){
            const bool = await this.$refs['baseform'].validate();
            if (!bool) {
                this.$VMessage.warning("请填写必填项");
            }
            return bool;
		},
    },
    filters:{
        filterType(type){
            switch(type){
                case 'single': return '简单产品' ; break;
                case 'bundle': return '组合产品' ; break;
                case 'virtual': return '虚拟产品' ; break;
            }
        },
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        },
        filterSalestate(type){
            switch(type){
                case 'Hit Shelve': return '上架' ; break;
                case 'Off Shelve': return '临时下架' ; break;
                case 'Not Sell': return '下架' ; break;
            }
        }
    },
    watch:{
        basedata(){
            this.handledata()
        }
    }
}
</script>